<template>
    <rkm-form ref="Form">
        <rkm-area
            type="section"
            title="Buscar exames agendados"
        >

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-date-picker
                        range
                        :range-inline="false"
                        :start-validations="validations.periodo"
                        :end-validations="validations.periodo"
                        start-label="Período de"
                        end-label="Até"
                        v-model="agendamento.periodo"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input-autocomplete
                        :repository="repositories.usuario"
                        :requestQueryStringParams="{ with_not_regularized: true }"
                        :searchFields="fields.autocomplete.usuario"
                        text-field="cidadaoNome"
                        label="Médico solicitante"
                        placeholder="Digite o nome ou número do conselho profissional"
                        v-model="agendamento.medicoSolicitante"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        :options="data.form.unidades"
                        label="Unidade solicitante"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="agendamento.unidadeId"
                        default-option-text="Selecione"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        label="Local de atendimento"
                        :options="infraestruturas"
                        textField="nome"
                        v-model="agendamento.infraestruturaId"
                        valueField="id"
                        show-default-option
                        :disabled="!agendamento.unidadeId"
                    />
                </rkm-col>

                <rkm-col cols="3" >
                    <rkm-form-input
                        label="Número do agendamento"
                        v-model="agendamento.agendamentoNumero"
                    />
                </rkm-col>

                <rkm-col class="flex-grow-1">
                    <rkm-form-checkbox
                        :label="false"
                        v-model="agendamento.urgente"
                    >
                        Agendamento urgente
                    </rkm-form-checkbox>
                </rkm-col>

                 <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click.stop="resetForm"
                        color="secondary"
                        class="float-right"
                    >
                        Limpar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="search()"
                        color="primary"
                        class="mr-2 float-right"
                    >
                        Buscar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-area>
     </rkm-form>
</template>

<script>

// Moment.
import moment from 'moment'

import { mapActions } from 'vuex'
import { repository, error, object, data, stringCase } from '@/mixins'

export default {
    computed:{
        fields() {
            return {
                autocomplete: {
                    usuario: [
                        { key: "cadastroCidadao.nome", searchable: true },
                        { key: "cadastroUsuario.registroNumero", searchable: true },
                    ],
                },
            }
        },
        infraestruturas() {

            if (this.agendamento.unidadeId) {

                let unidade = this.data.form.unidades.find(u => u.id === this.agendamento.unidadeId)

                if (unidade) {

                    this.handleInfraestrutura(unidade.infraestruturas)

                    return unidade.infraestruturas
                }
            } else {

                this.setInfraestrutura()
            }

            return []
        },
        validations() {
            return {
                periodo: { required: true },
            }
        },
    },
    created() {
        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
        }
    },
    data:() => ({
        cadastro:[],
        agendamento: {
            agendamentoNumero: null,
            infraestruturaId: null,
            urgente: null,
            medicoSolicitante: null,
            unidadeId: null,
            periodo: {
                start: null,
                end: null,
            },
        },
        dataAtual: '',
    }),
    methods:{
        ...mapActions(['setLoading', 'unsetLoading']),
        handleInfraestrutura(infraestrutura) {

            let localAtendimento = infraestrutura.find(u => u.principal)

            if(localAtendimento){

                this.agendamento.infraestruturaId = localAtendimento.id
            } else {

                this.agendamento.infraestruturaId = null
            }
        },
        search() {

            this.$refs.Form.validate().then(valid => {

                if (!valid) return

                let buscaAgendamento = this.data.model.agendamentos

                if(this.agendamento.unidadeId){

                    buscaAgendamento = buscaAgendamento
                        .filter(agendamento => agendamento.unidadeId == this.agendamento.unidadeId)
                }

                if(this.agendamento.infraestruturaId){

                    buscaAgendamento = buscaAgendamento
                        .filter(agendamento => agendamento.infraestruturaId == this.agendamento.infraestruturaId)
                }

                if(this.agendamento.medicoSolicitante){

                    buscaAgendamento = buscaAgendamento
                        .filter(agendamento => agendamento.medicoId == this.agendamento.medicoSolicitante.id)
                }

                if(this.agendamento.agendamentoNumero){

                    buscaAgendamento = buscaAgendamento
                        .filter(agendamento => agendamento.agendamentoNumero == this.agendamento.agendamentoNumero)
                }

                if(this.agendamento.urgente){

                    buscaAgendamento = buscaAgendamento
                        .filter(agendamento => agendamento.urgente == this.agendamento.urgente)
                }

                if (this.agendamento.periodo){

                    const start = moment(this.agendamento.periodo.start).subtract(1, 'day')
                    const end = moment(this.agendamento.periodo.end).add(1, 'day')

                    buscaAgendamento = buscaAgendamento.filter(agendamento =>

                        moment(new Date(agendamento.data.split("-").join("/")), 'DD/MM/YYYY').isBetween(start, end)
                    )
                }

                this.data.model.agendamentosSearch = buscaAgendamento

                this.$emit('handleSearch', true)
            })
        },
        resetForm() {

            this.agendamento.unidadeId = null
            this.agendamento.infraestruturaId = null
            this.agendamento.agendamentoNumero = null
            this.agendamento.urgente = null
            this.agendamento.medicoSolicitante = null
            this.agendamento.periodo.start = null
            this.agendamento.periodo.end = null
            this.data.model.agendamentosSearch = null

            this.$emit('handleSearch', false)

            this.$nextTick().then(() =>  this.$refs.Form.resetValidator())
        },
        setInfraestrutura() {
            this.agendamento.infraestruturaId = null
        },
    },
    mixins: [ repository, error, object, data, stringCase ],
    props: {
        data: { type: Object, required: true },
        paciente: { type: Object, required: true},
    },
}
</script>